import React, { useContext } from 'react';

import { Divider, Drawer, List } from '@mui/material';

import UserRoleContext from 'context/user-role/context';

import Items from './Items';
import MenuBottomSection from './MenuBottomSection';
import { useMenuActions } from './hooks/useMenuActions';

import { styles } from './style';

export default function SideBarMenu() {
  const { role } = useContext(UserRoleContext);
  const { returnPath, handleLogOut } = useMenuActions();

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = (access: boolean) => {
    setOpen(access);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Drawer
      variant="permanent"
      PaperProps={{
        sx: open ? styles.drawerOpen : styles.drawerClose,
      }}
      data-testid="drawer"
      onMouseEnter={() => {
        handleDrawerOpen(true);
      }}
      onMouseLeave={() => {
        handleDrawerClose();
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          position: 'relative',
        }}
      >
        <List sx={styles.list}>
          <Items
            open={open}
            role={role}
            closeDrawer={handleDrawerClose}
            returnPath={returnPath}
          />
        </List>
        <MenuBottomSection
          open={open}
          onLogOut={handleLogOut}
          variant="sidebar"
        />
      </div>
      <Divider />
    </Drawer>
  );
}
